/* eslint-disable react/no-unknown-property */
import React, { Component } from 'react'
import { InitativeCard } from '../PersonalProfile/style';
import PropTypes from 'prop-types';
import moment from 'moment';
// import {getLastSyncDetails} from "../../utils/methods";
import { ActivityBar, ActivityBarFill, ActivityBarFillV2, ActivityBarV2, ActivityContainer, CountDiv, /*OverviewCard, OverviewCardV2,*/ ShowPoints, WbaPoints, WbaReportCard, WbaCatgoryCard, QueAnsWrapper, BiometricInfoCard, InitiativesCard, GeneralInfoPopup, NewBiometricCard } from './styles';
import { isNull, isUndefined } from 'lodash';
import Waiting from '../Waiting';
import BiometricDetails from '../BiometricConfirmPopup/BiometricDetails';
import { withTranslation } from 'react-i18next';
import { MainContainer, TopContainerWrapper } from '../Recognition/RecognitionActivity/styles';
import { BorderBottom, TabBottomLine } from '../RecogntionAdmin/styles';
import { TabsWrapper } from '../common/commonStyles';
import Reports from './health/reports';
import {ProfileCompare, /*RecognitionEyeIcon,*/ CloseIconBranding, DropdownArrow, InfoIconBranding, EditIconBranding, RecognitionWarningIcon, AdminRightArrowIcon, closeIcon, GreatJobIcon, CongratulationsEmojiIcon, RecognitionTickIcon, NoWbaReportIcon, NoBiometricScreeningIcon} from '../../utils/icons'
import { ImageUrl } from '../../utils/constants';
import { ComparisonStyledModal, WrapperYear, YearDataComparisonCard } from "../Recognition/styles";
import {ModalTitle, Border, DropdownHeading } from '../RecogntionAdmin/styles'
import { Modal } from "react-bootstrap";
import {NewActivityDropdownCommon} from '../common/CommonDropDown/style';
import { Dropdown } from "react-bootstrap";
import { GetWellbeingAssessmentDetailsForUser, GetUserBiometric } from "../../redux/constants/apiConstants";
import { fetchApi } from "../../utils/methods";
import { toast } from "react-toastify";
import History from './health/history';
import dayjs from 'dayjs';
import {CommonButton} from '../common/commonStyles';
import { connect } from 'react-redux';
const ConfirmVisitPopup = React.lazy(() => import('../ContentV2/SideBarContiner/ConfirmVisitPopup'));
const ThankyouPopup = React.lazy(() => import('../ContentV2/SideBarContiner/ThankyouPopup'));
import ConfirmDetailsModal from '../ContentV2/SideBarContiner/ConfirmDetailsModal';
import { postUserInitiatives, getUserCompanyItitiatives, FetchSurveyQuestions, getListOfConnectedDevices, revokeDevice, SetDailyGoal, submitHealthInformation } from '../../redux/actions';
import {StyledModal, InitiativesContainer, ButtonContainer, ConfirmButton} from '../ContentV2/SideBarContiner/Styles';
import parse from 'react-html-parser';
import ConnectDeviceModal from '../ConnectDeviceModal';
import InputGoalV2 from '../../components/InputGoalsV2/index'
import {CommonFilterDropdown} from '../common/CommonYearFilter/CommonYearFilter'
import { ProgressBar } from '../HealthTabV2/HealthTabUpdated/styles';
import { CommonButtonPopup } from '../ReportsV2/styles';
import UserInitiativePopup from '../UserDashboard/Initiatives/userInitiativePopup';
import InitiativeCompleteModal from '../UserDashboard/Initiatives/initiativeCompleteModal';

class HealthAndWellness extends Component {

  constructor(props) {
    super(props);
    this.state = {
      biometricPopupStatus: false,
      activeTab:"health-hub",
      showCompareYear: false,
      comparisonToYear:2024,
      comparisonFromYear: 2025,
      comparisonToYearData:{},
      comparisonFromYearData:{},
      biometricDetails:{},
      showBiometricInfoPopup: false,
      confirmVisit: false,
      showThankyou: false,
      showConfirmVisitModal: false,
      currentDate: new Date(),
      initiativeData: [],
      showPopup: false,
      isConfirmDetails: false,
      showDeviceModal: false,
      modalName: false,
      exercisePerWeek:props?.health[0]?.exercise_day_per_week,
      smoke:props?.health[0]?.do_you_smoke,
      physicalExam: props?.health[0]?.physical_exam_frequency,
      averageSleep:props?.health[0]?.average_sleep_per_night,
      waterIntake: props?.health[0]?.average_water_intake,
      bodyPain: props?.health[0]?.pain_experience,
      prescription: props?.health[0]?.prescription_intake,
      physicalActive: props?.health[0]?.minute_active,
      isEditInfo: false,
      isEditInfoValue: false
    }
  }

  componentDidMount(){
    const {user, getUserCompanyItitiatives}=this.props;
    this.getBiometricDetails(user?.uid)
    getUserCompanyItitiatives();
  }

  getWellneeDataToYear = async (year) => {
    try {
      const res = await fetchApi(`/${GetWellbeingAssessmentDetailsForUser}/${year}`, "GET");
      if (res?.data?.message) {
        toast.error(res?.data?.message);
      } else {
        this.setState({
          comparisonToYearData: res?.data,
        })
      }
    } catch (error) {
      toast.error(error?.message);
    }
  };

  getWellneeDataFromYear = async (year) => {
    try {
      const res = await fetchApi(`/${GetWellbeingAssessmentDetailsForUser}/${year}`, "GET");
      if (res?.data?.message) {
        toast.error(res?.data?.message);
      } else {
        this.setState({
          comparisonFromYearData: res?.data,
        })
      }
    } catch (error) {
      toast.error(error);
    }
  };

  getBiometricDetails = async (user) => {
    try {
      const res = await fetchApi(`${GetUserBiometric}/${user}`, "GET");
      if (res.message) {
        toast.error(res.message);
      } else {
        this.setState({
          biometricDetails: res.data,
        })
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  showBiometricSubmitStatusPop = () => {
    this.setState((prevState) => ({biometricPopupStatus: !prevState.biometricPopupStatus}))
  }

  getWellbeingPercentage = (value) => {
    if (value) {
      return `${(value / 40) * 100}%`
    }
    else {
      return '0%';
    }
  }

  getTotalWellbeingPercentage = (value) => {
    if (value) {
      return `${Math.round((value / 240) * 100)}%`;
    }
    else {
      return '0%';
    }
  }

  getTotalWellbeingAssesment = (wellnessAssessment) => {
    if (wellnessAssessment && !isNull(wellnessAssessment.lifestyle && wellnessAssessment.fitness && wellnessAssessment.nutrition && wellnessAssessment.stress && wellnessAssessment.workplace)) {
      let total = wellnessAssessment.lifestyle + wellnessAssessment.fitness + wellnessAssessment.nutrition + wellnessAssessment.stress + wellnessAssessment.workplace
      const wellbeingTotalAssesmentData = [
        {
          // title: 'Lifestyle',
          fill1: this.getTotalWellbeingPercentage(total),
          fillColor1: '#ffffff',
          backgroundFill1: 'rgba(255, 255, 255, 0.15)',
          imgUrl: '/public/images/userrlifestyle.png',
          width: '13px',
          label: total,
        },
      ]
      return (
        <React.Fragment>
          {wellbeingTotalAssesmentData && wellbeingTotalAssesmentData.length > 0 && wellbeingTotalAssesmentData.map((item,index) => (
            <WbaPoints style={{ background: "#0D4270", alignItems: 'center' }} key={index}>
              <div style={{ width: '25%', display: 'flex', alignItems: 'center', color: 'white', fontFamily: 'rubik-medium', fontSize: '16px', lineHeight: '20px' }}>
                <div>Total</div>
              </div>
              <div>
                <ActivityContainer bloodPressure="5px 0 2px 0" width={'95%'} style={{ marginBottom: '10px' }}>
                  <ActivityBarV2 fillColor={item.fillColor1} backgroundFill={item.backgroundFill1}>
                    <ActivityBarFillV2 width={item.fill1} fillColor={item.fillColor1} >
                    </ActivityBarFillV2>
                  </ActivityBarV2>
                  <ShowPoints style={{ color: "#ffffff", width: '70px', marginTop: '2px' }}>
                    {wellnessAssessment.lifestyle + wellnessAssessment.fitness + wellnessAssessment.nutrition + wellnessAssessment.stress + wellnessAssessment.workplace}/200
                  </ShowPoints>
                </ActivityContainer>
              </div>
            </WbaPoints>))}
        </React.Fragment>
      )
    }
  }

  getWellbeingAssesment = (wellnessAssessment) => {
    const wellbeingAssesmentData = [
      {
        title: 'Lifestyle',
        fill1: wellnessAssessment && !isNull(wellnessAssessment.lifestyle) ? this.getWellbeingPercentage(wellnessAssessment.lifestyle) : 0,
        fillColor1: 'rgb(157, 135, 169)',
        backgroundFill1: 'rgba(157, 135, 169, 0.15)',
        imgUrl: '/public/images/userrlifestyle.png',
        width: '13px',
        label: wellnessAssessment && !isNull(wellnessAssessment.lifestyle) ? wellnessAssessment.lifestyle : 0,
      },
      {
        title: 'Physical Activity',
        fill1: wellnessAssessment && !isNull(wellnessAssessment.fitness) ? this.getWellbeingPercentage(wellnessAssessment.fitness) : 0,
        fillColor1: 'rgb(105, 194, 255)',
        backgroundFill1: 'rgba(105, 194, 255, 0.15)',
        imgUrl: '/public/images/userrfitness.png',
        width: '20px',
        label: wellnessAssessment && !isNull(wellnessAssessment.fitness) ? wellnessAssessment.fitness : 0
      },
      {
        title: 'Nutrition',
        fill1: wellnessAssessment && !isNull(wellnessAssessment.nutrition) ? this.getWellbeingPercentage(wellnessAssessment.nutrition) : 0,
        fillColor1: 'rgb(159, 201, 137)',
        backgroundFill1: 'rgba(159, 201, 137, 0.15)',
        imgUrl: '/public/images/userrNutrition.png',
        width: '13px',
        label: wellnessAssessment && !isNull(wellnessAssessment.nutrition) ? wellnessAssessment.nutrition : 0
      },
      {
        title: 'Emotional Wellness',
        fill1: wellnessAssessment && !isNull(wellnessAssessment.stress) ? this.getWellbeingPercentage(wellnessAssessment.stress) : 0,
        fillColor1: 'rgb(255, 153, 134)',
        backgroundFill1: 'rgba(255, 153, 134, 0.15)',
        imgUrl: '/public/images/userremotional_wellness.png',
        width: '13px',
        label: wellnessAssessment && !isNull(wellnessAssessment.stress) ? wellnessAssessment.stress : 0
      },
      {
        title: 'WorkPlace Wellness',
        fill1: wellnessAssessment && !isNull(wellnessAssessment.workplace) ? this.getWellbeingPercentage(wellnessAssessment.workplace) : 0,
        fillColor1: 'rgb(246, 180, 121)',
        backgroundFill1: 'rgba(246, 180, 121, 0.15)',
        imgUrl: '/public/images/userrworkplace.png',
        width: '21px',
        label: wellnessAssessment && !isNull(wellnessAssessment.workplace) ? wellnessAssessment.workplace : 0
      }
    ];

    return (
      <InitativeCard>
        <div className='company-initative'>
          <div className='heading'>
            {this.props.t("My")} {moment().format('YYYY')} {this.props.t("WBA Report")}&nbsp;
            <div className='button-container'>
              <button style={{ minWidth: '170px', background: '#69c2ff' }} onClick={() => this.props.userModal()} className='detail-button'>{this.props.t("View Comparison")}</button>
              {/* <button onClick={() => this.props.history.push('/wellness-assessment/score')} className='detail-button'>View Full HRA</button> */}
            </div>
          </div>
          <hr className='horizontal-line2' />
          <div className='fitness-wrapper'>
            {wellbeingAssesmentData && wellbeingAssesmentData.length > 0 && wellbeingAssesmentData.map((item, index) => (
              <WbaPoints key={index} id={item.title} marginRight={(index + 1) % 3 === 0 ? "0px" : "25px"}>
                <div>
                  <img src={item.imgUrl} backgroundFill={item.backgroundFill1} />
                </div>
                <div>
                  <div>{this.props.t(item.title)}</div>
                  <CountDiv style={{ color: '#69C2FF' }}>
                    <ActivityContainer key={index} bloodPressure="5px 0 2px 0" width={'95%'}>
                      <ActivityBar fillColor={item.fillColor1} backgroundFill={item.backgroundFill1}>
                        <ActivityBarFill width={item.fill1} fillColor={item.fillColor1}>
                        </ActivityBarFill>
                      </ActivityBar>
                      <ShowPoints>
                        {this.props.t(item.label)}/40
                      </ShowPoints>
                    </ActivityContainer>
                  </CountDiv>
                </div>
              </WbaPoints>))}
            {this.getTotalWellbeingAssesment(wellnessAssessment)}
          </div>
        </div>
      </InitativeCard>
    )
  };

  yearDropDownTo = (year) =>{
    this.setState({
      comparisonToYear:year
    }, () => this.getWellneeDataToYear(year));
  }

  yearDropDownFrom = (year) =>{
    this.setState({
      comparisonFromYear:year
    }, () => this.getWellneeDataFromYear(year));
  }

  hideShowCompareYear = ()=>{
    const { comparisonToYear, comparisonFromYear } = this.state;
    this.getWellneeDataToYear(comparisonToYear);
    this.getWellneeDataFromYear(comparisonFromYear)
    this.setState({
      showCompareYear: !this.state.showCompareYear
    })
  }

  comparisonModal = () => {
    const{comparisonToYearData, comparisonFromYearData}=this.state;
    const EngagementEmployeeData = [
      {
        title: "Total Score",
        value: "0",
        img: null,
        fromCount: comparisonFromYearData?.medical+comparisonFromYearData?.lifestyle+comparisonFromYearData?.fitness+comparisonFromYearData?.nutrition+comparisonFromYearData?.stress+comparisonFromYearData?.workplace+"/240",
        toCount: comparisonToYearData?.medical+comparisonToYearData?.lifestyle+comparisonToYearData?.fitness+comparisonToYearData?.nutrition+comparisonToYearData?.stress+comparisonToYearData?.workplace+"/240",
        totalCount: "Posts",
        color: "#DA92C8",
        borderRadius: "11px",
        difference:(comparisonFromYearData?.medical+comparisonFromYearData?.lifestyle+comparisonFromYearData?.fitness+comparisonFromYearData?.nutrition+comparisonFromYearData?.stress+comparisonFromYearData?.workplace)-(comparisonToYearData?.medical+comparisonToYearData?.lifestyle+comparisonToYearData?.fitness+comparisonToYearData?.nutrition+comparisonToYearData?.stress+comparisonToYearData?.workplace),
        differenceType:(comparisonFromYearData?.medical+comparisonFromYearData?.lifestyle+comparisonFromYearData?.fitness+comparisonFromYearData?.nutrition+comparisonFromYearData?.stress+comparisonFromYearData?.workplace)-(comparisonToYearData?.medical+comparisonToYearData?.lifestyle+comparisonToYearData?.fitness+comparisonToYearData?.nutrition+comparisonToYearData?.stress+comparisonToYearData?.workplace)>0?'plus':'minus',
      },
      {
        title: "Health",
        value: "1",
        img: '/profile-page/health.svg',
        fromCount: `${comparisonFromYearData?.medical}/40`,
        toCount: `${comparisonToYearData?.medical}/40`,
        totalCount: "Posts",
        color: "#DA92C8",
        borderRadius: "11px",
        difference:comparisonFromYearData?.medical-comparisonToYearData?.medical,
        differenceType: comparisonFromYearData?.medical-comparisonToYearData?.medical>0?"plus":"minus",
      },
      {
        title: "Lifestyle",
        value: "1",
        img: '/profile-page/lifestyle.svg',
        fromCount: `${comparisonFromYearData?.lifestyle}/40`,
        toCount: `${comparisonToYearData?.lifestyle}/40`,
        totalCount: "Posts",
        color: "#DA92C8",
        borderRadius: "11px",
        difference:comparisonFromYearData?.lifestyle-comparisonToYearData?.lifestyle,
        differenceType: comparisonFromYearData?.lifestyle-comparisonToYearData?.lifestyle>0?"plus":"minus",
      },
      {
        title: "Fitness",
        value: "2",
        img: '/profile-page/fitness.svg',
        fromCount: `${comparisonFromYearData?.fitness}/40`,
        toCount: `${comparisonToYearData?.fitness}/40`,
        totalCount: "People Received",
        color: "#91C49D",
        difference:comparisonFromYearData?.fitness-comparisonToYearData?.fitness,
        differenceType:comparisonFromYearData?.fitness-comparisonToYearData?.fitness>0? 'plus':'minus',
      },
      {
        title: "Nutrition",
        value: "3",
        img: '/profile-page/nutrition.svg',
        fromCount: `${comparisonFromYearData?.nutrition}/40`,
        toCount: `${comparisonToYearData?.nutrition}/40`,
        totalCount: "People Gave",
        color: "#BE7D9C",
        difference:comparisonFromYearData?.nutrition-comparisonToYearData?.nutrition,
        differenceType: comparisonFromYearData?.nutrition-comparisonToYearData?.nutrition>0?'plus':'minus',
      },
      {
        title: "Mental Health",
        value: "4",
        img: '/profile-page/mental.svg',
        fromCount: `${comparisonFromYearData?.stress}/40`,
        toCount: `${comparisonToYearData?.stress}/40`,
        totalCount: "People Exemplified",
        color: "#B1AA56",
        difference:comparisonFromYearData?.stress-comparisonToYearData?.stress,
        differenceType:comparisonFromYearData?.stress-comparisonToYearData?.stress>0?'plus': 'minus',
      },
      {
        title: "Workplace Wellness",
        value: "5",
        img: '/profile-page/workplace.svg',
        fromCount: `${comparisonFromYearData?.workplace}/40`,
        toCount: `${comparisonToYearData?.workplace}/40`,
        totalCount: "People Exemplified",
        color: "#B1AA56",
        difference:comparisonFromYearData?.workplace-comparisonToYearData?.workplace,
        differenceType:comparisonFromYearData?.workplace-comparisonToYearData?.workplace>0?'plus': 'minus',
      },
    ];
    window.console.log("EngagementEmployeeData",EngagementEmployeeData)
    const {userCompany} = this.props;
    const currentYear = new Date().getFullYear();
    let yearList = [];
    if (!isNull(userCompany?.id)) {
      for (let i = currentYear; i >= userCompany["companyStartDate"].company_start_date; i--) {
        yearList.push(i);
      }
    }
    const {showCompareYear, comparisonFromYear, comparisonToYear} =this.state;
    return (
      <ComparisonStyledModal
        show={showCompareYear}
        onHide={this.hideShowCompareYear}
        dialogClassName="modal-90w"
        style={{ overflowY:'hidden'}}
        border="1"
      >
        <ModalTitle style={{padding:"16px 24px 0px 24px"}}>
          <div className='title'>My WBA Reports Comparison</div>
          <div className='close' onClick={this.hideShowCompareYear} >{CloseIconBranding()}</div>
        </ModalTitle>
        <Border margin="16px 0"/>
        <Modal.Body  style={{padding:"16px 24px"}} >
          <DropdownHeading>
            <div className='name'>Select a year</div>
            <div className='name'>Select a year</div>
          </DropdownHeading>
          <WrapperYear style={{width:"100%", display:"flex", justifyContent:"space-between"}}>
            <NewActivityDropdownCommon
              style={{width:"364px"}}
              border
            >
              <Dropdown.Toggle>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",fontFamily: "Lato", fontSize: "16px", fontWeight: "400", lineHeight: "20px", color: "#184A61"}}>
                  <div>{comparisonToYear}</div>
                  {yearList?.length>1?<div>
                    {DropdownArrow()}
                  </div>:null}
                </div>
              </Dropdown.Toggle>
              {yearList?.length>1?<Dropdown.Menu>
                {yearList?.map((list, index) => (
                  comparisonFromYear>list&&
                  <Dropdown.Item
                    key={index}
                    onClick={() => this.yearDropDownTo(list)}
                  >
                    {list}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>:null}
            </NewActivityDropdownCommon>
            <NewActivityDropdownCommon
              style={{width:"364px"}}
              border
            >
              <Dropdown.Toggle>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",fontFamily: "Lato", fontSize: "16px", fontWeight: "400", lineHeight: "20px", color: "#184A61"}}>
                  <div>{comparisonFromYear}</div>
                  {yearList?.length>1?<div>
                    {DropdownArrow()}
                  </div>:null}
                </div>
              </Dropdown.Toggle>
              {yearList?.length>1?<Dropdown.Menu>
                {yearList?.map((list, index) => (
                  <Dropdown.Item
                    key={index}
                    onClick={() => this.yearDropDownFrom(list)}                  >
                    {list}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>:null}
            </NewActivityDropdownCommon>
          </WrapperYear>
          <Border margin="24px 0 12px 0"/>
          <div style={{ width:'100%'}}>

            {EngagementEmployeeData.map((item,index)=>(
              <YearDataComparisonCard key={index} background={"transparent"} padding="14px 14px 14px 8px">
                {item?.img&&<div className="image-category">
                  <img src={ImageUrl +  item.img}/>
                </div>}
                <div className="category-title">
                  {item.title}
                </div>
                {index===0&&<div className="image-category"/>}
                <div className="typeValue">
                  <div className="value">{item.toCount}</div>
                </div>
                {item.difference==0?
                  <div className="arrows" style={{justifyContent:"center"}}>
                    <div className={"percentOrange"}>{item.difference}</div>
                  </div>
                  :<span className="arrows">
                    <img style={{marginLeft:'5px'}} src={`${ImageUrl}/admin-recognition/${item.differenceType}.svg`}/>
                    {item.differenceType === "plus"?<span className={"percent"}>+{item.difference}</span>:<span className={"percentRed"}>{item.difference}</span>}
                  </span>}
                <div className="newData">
                  {item.fromCount}
                </div>
              </YearDataComparisonCard>))}
          </div>
        </Modal.Body>
      </ComparisonStyledModal>
    );
  };

  biometricInfoPopup = () => {
    const {showBiometricInfoPopup}=this.state;
    return(
      <ComparisonStyledModal
        show={showBiometricInfoPopup}
        dialogClassName="modal-90w"
        style={{ overflowY:'hidden',left:"6%"}}
        border="1"
        width="400px"
      >
        <ModalTitle style={{padding:"16px 24px 0px 24px"}}>
          <div className='title'>
            {RecognitionWarningIcon("#B1AA56")}
            Biometric Screening Information
          </div>
          <div className='close' onClick={()=>this.hideshowbiometricpopup()} >{CloseIconBranding()}</div>
        </ModalTitle>
        <Border margin="20px 16px" style={{width:"368px"}}/>
        <BiometricInfoCard color='#91C49D'>
          <div className='color'/>
          <div className='text'>Parameters within normal range are denoted in green.</div>
        </BiometricInfoCard>
        <BiometricInfoCard color='#B1AA56'>
          <div className='color'/>
          <div className='text'>Borderline values are marked in yellow.</div>
        </BiometricInfoCard>
        <BiometricInfoCard color='#DA6C74'>
          <div className='color'/>
          <div className='text'>Parameters with abnormal values are highlighted in red.</div>
        </BiometricInfoCard>
        <div className='submit-button'>
          <CommonButton margin="12px 0 16px 0" onClick={()=>this.hideshowbiometricpopup()}>Got it</CommonButton>
        </div>
      </ComparisonStyledModal>
    )
  }

  getWbaReport = (wellnessAssessment) => {
    const wellbeingAssesmentData = [
      {
        title: 'Health',
        fill1: wellnessAssessment && !isNull(wellnessAssessment?.medical) ? (wellnessAssessment?.medical) : 0,
        fillColor1: 'rgb(157, 135, 169)',
        backgroundFill1: 'rgba(157, 135, 169, 0.15)',
        imgUrl: '/profile-page/health.svg',
        width: '13px',
        color: "#DA6C74",
        label: wellnessAssessment && !isNull(wellnessAssessment?.medical) ? wellnessAssessment?.medical : 0,
        type:'medical'
      },
      {
        title: 'Lifestyle',
        fill1: wellnessAssessment && !isNull(wellnessAssessment.lifestyle) ? (wellnessAssessment.lifestyle) : 0,
        fillColor1: 'rgb(157, 135, 169)',
        backgroundFill1: 'rgba(157, 135, 169, 0.15)',
        imgUrl: '/profile-page/lifestyle.svg',
        width: '13px',
        color: "#B1AA56",
        label: wellnessAssessment && !isNull(wellnessAssessment.lifestyle) ? wellnessAssessment.lifestyle : 0,
        type:'lifestyle'
      },
      {
        title: 'Fitness',
        fill1: wellnessAssessment && !isNull(wellnessAssessment.fitness) ? (wellnessAssessment.fitness) : 0,
        fillColor1: 'rgb(105, 194, 255)',
        backgroundFill1: 'rgba(105, 194, 255, 0.15)',
        imgUrl: '/profile-page/fitness.svg',
        width: '20px',
        color: "#DA9B6C",
        label: wellnessAssessment && !isNull(wellnessAssessment.fitness) ? wellnessAssessment.fitness : 0,
        type:'fitness'
      },
      {
        title: 'Nutrition',
        fill1: wellnessAssessment && !isNull(wellnessAssessment.nutrition) ? (wellnessAssessment.nutrition) : 0,
        fillColor1: 'rgb(159, 201, 137)',
        backgroundFill1: 'rgba(159, 201, 137, 0.15)',
        imgUrl: '/profile-page/nutrition.svg',
        width: '13px',
        color: "#75B084",
        label: wellnessAssessment && !isNull(wellnessAssessment.nutrition) ? wellnessAssessment.nutrition : 0,
        type:'nutrition'
      },
      {
        title: 'Mental Health',
        fill1: wellnessAssessment && !isNull(wellnessAssessment.stress) ? (wellnessAssessment.stress) : 0,
        fillColor1: 'rgb(255, 153, 134)',
        backgroundFill1: 'rgba(255, 153, 134, 0.15)',
        imgUrl: '/profile-page/mental.svg',
        width: '13px',
        color: "#BE7D9C",
        label: wellnessAssessment && !isNull(wellnessAssessment.stress) ? wellnessAssessment.stress : 0,
        type:'mentalhealth'
      },
      {
        title: 'Workplace',
        fill1: wellnessAssessment && !isNull(wellnessAssessment.workplace) ? (wellnessAssessment.workplace) : 0,
        fillColor1: 'rgb(246, 180, 121)',
        backgroundFill1: 'rgba(246, 180, 121, 0.15)',
        imgUrl: '/profile-page/workplace.svg',
        width: '21px',
        color: "#92A4DA",
        label: wellnessAssessment && !isNull(wellnessAssessment.workplace) ? wellnessAssessment.workplace : 0,
        type:'workplace'
      }
    ];
    const totalCount=wellbeingAssesmentData[0]?.fill1+wellbeingAssesmentData[1]?.fill1+wellbeingAssesmentData[2]?.fill1+wellbeingAssesmentData[3]?.fill1+wellbeingAssesmentData[4]?.fill1+wellbeingAssesmentData[5]?.fill1;
    const totalPercentage=this.getTotalWellbeingPercentage(totalCount)
    const {showHRAPopUp}= this.props;
    return (
      <>
        {/* <WbaReportCard>
        <div className='heading'>
          <div className='start'>
            <div className='title'>My WBA Reports</div>
            <div className='line'/>
            <div className='total'>Total Score: {totalCount}/240 | {totalPercentage}</div>
          </div>
          <div className='end'>
            <div className='icon' style={{marginRight:'8px'}} onClick={() => this.hideShowCompareYear()}><ProfileCompare/></div>
            {showHRAPopUp&&<>
              <div className='icon' onClick={() => this.props.history.push({ pathname: `/profile/health-report`, state: { wellbeingAssesmentData: wellbeingAssesmentData,key:7 } })}>{RecognitionEyeIcon("#F37A65")}</div>
              <div className='view-report' onClick={() => this.props.history.push({ pathname: `/profile/health-report`, state: { wellbeingAssesmentData: wellbeingAssesmentData,key:7 } })}>View Full Report</div>
            </>}
          </div>
        </div>
        <div className='border'/>
        <div className='category-wrapper'>
          {wellbeingAssesmentData.map((item, index) => {
            const circumference = 2 * Math.PI * 50; // Adjust radius if needed
            const offset = circumference - (item?.fill1 / 40) * circumference; // 40% of total
            return (
              <WbaCatgoryCard key={index} style={{width:"200px"}}>
                <div className='category'>
                  <img src={ImageUrl + item?.imgUrl} alt={item.title} />
                </div>
                <div className='category-name'>{item.title}</div>

                <div className="progress-container">
                  <svg width="120" height="120" viewBox="0 0 120 120">
                    <circle cx="60" cy="60" r="50" stroke="#ddd" strokeWidth="6" fill="none" />

                    <circle
                      className="progress-ring"
                      cx="60"
                      cy="60"
                      r="50"
                      stroke={item.color}
                      strokeWidth="6"
                      fill="none"
                      strokeLinecap="round"
                      strokeDasharray={circumference}
                      strokeDashoffset={offset} // Directly use offset
                      style={{ transition: "stroke-dashoffset 0.5s ease-in-out" }}
                    />
                  </svg>

                  <span className="progress-text">{item.fill1}/40</span>
                </div>
              </WbaCatgoryCard>
            );
          })}

        </div>
      </WbaReportCard> */}

        <WbaReportCard style={{width:'50%'}}>
          <div className='heading' style={{marginBottom:'20px'}}>
            <div className='start'>
              <div className='title'>Wellbeing Assessment</div>
              {/* <div className='line'/> */}
              {/* <div className='total'>Total Score: {totalCount}/240 | {totalPercentage}</div> */}
            </div>
            <div className='end'>
              <div className='icon' style={{marginRight:'8px'}} onClick={() => this.hideShowCompareYear()}><ProfileCompare/></div>
              {/* {showHRAPopUp&&<>
                <div className='icon' onClick={() => this.props.history.push({ pathname: `/profile/health-report`, state: { wellbeingAssesmentData: wellbeingAssesmentData,key:7 } })}>{RecognitionEyeIcon("#F37A65")}</div>
                <div className='view-report' onClick={() => this.props.history.push({ pathname: `/profile/health-report`, state: { wellbeingAssesmentData: wellbeingAssesmentData,key:7 } })}>View Full Report</div>
              </>} */}
            </div>
          </div>

          <div className='category-wrapper-new' style={{position:'relative',minHeight:'494px'}}>
            {showHRAPopUp ? <> <div className='total'>Total Score: {totalCount}/240 | {totalPercentage}</div> 
              <div className='border' style={{margin:'12px 0px'}}/>
              {wellbeingAssesmentData.map((item, index) => {
                {/* const circumference = 2 * Math.PI * 50; // Adjust radius if needed */}
                {/* const offset = circumference - (item?.fill1 / 40) * circumference; // 40% of total */}
                return (
                  <WbaCatgoryCard key={index} style={{width:"100%"}}>
                    <div className='category' style={{margin:'12px 0px', justifyContent:'space-between'}}>
                      <div style={{display:'flex',alignItems:'center'}}>
                        <img src={ImageUrl + item?.imgUrl} alt={item.title} />
                        <div className='category-name-new'>{item.title}</div>
                      </div>
                      <div className='category-name-new'>
                        {item.fill1}/40
                      </div>
                    </div>
     
                    <div className="bar">
                      <ProgressBar radius="1" height={"8px"} backgroundActive={item.color} background={'#F8F8F8'} width={(item.fill1/40)*100}>
                        <div className="progress" style={{borderRadius:'12px'}}></div>
                      </ProgressBar>
                      {/* <svg width="120" height="120" viewBox="0 0 120 120">
                        <circle cx="60" cy="60" r="50" stroke="#ddd" strokeWidth="6" fill="none" />
     
                        <circle
                          className="progress-ring"
                          cx="60"
                          cy="60"
                          r="50"
                          stroke={item.color}
                          strokeWidth="6"
                          fill="none"
                          strokeLinecap="round"
                          strokeDasharray={circumference}
                          strokeDashoffset={offset} // Directly use offset
                          style={{ transition: "stroke-dashoffset 0.5s ease-in-out" }}
                        />
                      </svg>
     
                      <span className="progress-text">{item.fill1}/40</span> */}
                    </div>
                  </WbaCatgoryCard>
                );
              })}
              <div style={{display:'flex', justifyContent:'center'}}>
                <CommonButtonPopup height="40px" width="300px" margin="70px 0px 0px 0px" background={'#DA6C74'} onClick={() => this.props.history.push({ pathname: `/profile/health-report`, state: { wellbeingAssesmentData: wellbeingAssesmentData,key:7 } })}>
                  View Full Report
                </CommonButtonPopup>
              </div> </>: null}

            {!showHRAPopUp ? <>
              <div className='no-data-text'>
              Your wellbeing goes beyond physical health. Take a few minutes to complete your Wellbeing Assessment (WBA) and get personalized insights into your overall balance and growth.
              </div>
              <CommonButtonPopup height="40px" width="300px" margin="16px 0px 0px 0px" background={'#DA6C74'} onClick={() => this.props.history.push('/wellness-assessment')}>
                Take the Assessment
              </CommonButtonPopup>
              <div className='no-data-icon'>{NoWbaReportIcon()}</div>
            </> : null}
   
          </div>
        </WbaReportCard>
      </>
    )
  };

  roundNumber = (num) => {
    const rounded = Math.round(num * 10) / 10;
    return Number.isInteger(rounded) ? rounded.toFixed(0) : rounded;
  };

  getBiometricReport = () => {
    const {userBiometric,user}=this.props;
    const {biometricDetails} = this.state
    const biometricData = [
      {
        title: 'Weight',
        value: this.roundNumber(userBiometric?.weight)+ " lb",
        color: "#91C49D",
      },
      {
        title: 'Height',
        value: userBiometric?.height,
        color: "#91C49D",
      },
      {
        title: 'Waist',
        value: this.roundNumber(userBiometric?.waist_circumference)+" in",
        color: "#91C49D",
      },
      {
        title: 'BMI',
        value: this.roundNumber(userBiometric?.bmi),
        color: "#91C49D",
      },
      {
        title: 'Systolic Blood Pressure',
        value: this.roundNumber(userBiometric?.blood_pressure_sys) +" mm/Hg",
        color: "#DA6C74",
      },
      {
        title: 'HDL Cholesterol',
        value: this.roundNumber(userBiometric?.cholestrol_hdl)+ " mg/dl",
        color: "#DA6C74",
      },
      {
        title: 'LDL Cholesterol',
        value: this.roundNumber(userBiometric?.cholestrol_ldl) +" mg/dl",
        color: "#B1AA56",
      },
      {
        title: 'Triglycerides',
        value: this.roundNumber(userBiometric?.triglycerides)+ " mg/dl",
        color: "#91C49D",
      },
      {
        title: 'Glucose',
        value: this.roundNumber(userBiometric?.glucose)+ " mg/dl",
        color: "#91C49D",
      },
      {
        title: 'Diastolic Blood Pressure',
        value: this.roundNumber(userBiometric?.blood_pressure_dia)+ " mm/Hg",
        color: "#B1AA56",
      }  
    ];
    const completedDate=dayjs(new Date(biometricDetails?.biometric_details?.physicianFormTimestamp)).format("MMMM DD"); // Format the date as "15, Jan"
    return(
      <WbaReportCard style={{width:'50%',marginLeft:'20px'}}>
        <div className='heading'>
          <div className='new-start'>
            <div className='title'>Biometric Screening</div>
            <div className='icon' onClick={()=>this.hideshowbiometricpopup()}>{InfoIconBranding()}</div>
          </div>
        </div>
        <div style={{flexWrap:"wrap",gap:"20px 8px",minHeight:'494px',position:'relative'}} className='biometric-card'>
          {userBiometric?.weight && biometricData?.map((data,index)=>(
            <NewBiometricCard key={index} color={data.color}>
              <div className='wrap'>
                <div className='field'>{data?.title}</div>
                
                <div className='value-container'>
                  <div className='circle'/>
                  <div className='value'>{data?.value}</div>
                </div>
              </div>

              <Border style={{background:'#EFEFEF',margin:'14px 0px 12px 0px'}}/>
            </NewBiometricCard>))}
          {userBiometric?.weight ? <div className='biometric-complete-new'>Biometric screening was completed on {completedDate}.</div> : null}
          {!userBiometric?.weight ? <>
            <div className='no-data-text'>
            Get a deeper look at your health. Visit your doctor for a Biometric Assessment, then upload or enter your results in Woliba to unlock personalized health insights.
            </div>
            <CommonButtonPopup height="40px" width="300px" margin="16px 0px 0px 0px" background={'#DA6C74'} onClick={() => this.props.history.push(`/profile/biometric/${user.uid}/multi-step/physician-form`)}>
                Upload My Results
            </CommonButtonPopup>
            {/* <div className='no-data-icon'>{NoWbaReportIcon()}</div> */}
            <div className='no-data-icon'>{NoBiometricScreeningIcon()}</div>
          </> : null}
        </div>
        {/* <div className='border'/> */}
      </WbaReportCard>
    )
  }

  generalInfoCard = () => {
    const {health}=this.props;
    const generalInfo= [
      {
        question: "How many days a week do you exercise?",
        answer: health[0]?.exercise_day_per_week,
      },
      {
        question: "Do you smoke?",
        answer: health[0]?.do_you_smoke,
      },
      {
        question: "How often do you have a physical exam?",
        answer: health[0]?.physical_exam_frequency,
      },
      {
        question: "How many hours of sleep do you get on average each night?",
        answer: health[0]?.average_sleep_per_night,
      },
      {
        question: "What is your average daily water intake?",
        answer: health[0]?.average_water_intake,
      },
      {
        question: "How frequently do you experience body pain?",
        answer: health[0]?.pain_experience,
      },
      {
        question: "How many prescription medications do you take each day?",
        answer: health[0]?.prescription_intake,
      },
      {
        question: "How many minutes are you physically active each day?",
        answer: health[0]?.minute_active,
      }
    ];
    return(
      <WbaReportCard>
        <div className='heading'>
          <div className='start'>
            <div className='title'>General Health Information</div>
          </div>
          <div className='end' onClick={()=>this.setState({isEditInfo:true})}>
            <div className='view-report'>Edit</div>
            <div className='icon'>{EditIconBranding()}</div>
          </div>
        </div>
        <div className='border'/>
        <QueAnsWrapper  margin="0" padding="0" color='transparent'>
          <div className="wrapper">
            {generalInfo?.map((data,index)=>
              <>
                <div className="content">
                  <div className="question">{data?.question}</div>
                  <div className="answer">{data?.answer}</div>
                </div>
                {index+1!==generalInfo?.length&&<div className="border"/>}
              </>)}
          </div>
        </QueAnsWrapper>
      </WbaReportCard>
    )
  }

  selectOptionValue = (value, state) =>{
    this.setState({
      [state]: value,
      isEditInfoValue: true
    })
  }

  editGeneralProfileInfo = () =>{
    const {exercisePerWeek, smoke, physicalExam, averageSleep, waterIntake, bodyPain, prescription, physicalActive, isEditInfoValue}=this.state;
    const {submitHealthInformation} = this.props
    const info ={
      "average_sleep_per_night": averageSleep,
      "physical_exam_frequency": physicalExam,
      "average_water_intake": waterIntake,
      "pain_experience": bodyPain,
      "prescription_intake": prescription,
      "smoke": smoke,
      "exercise_day_per_week":exercisePerWeek,
      "minute_active": physicalActive
    }
    if(isEditInfoValue){
      this.setState({isEditInfo:false},() => submitHealthInformation(info))
    }else{
      this.setState({isEditInfo:false})
    }
  }

  editGeneralInfoCard = () => {
    const {t}=this.props;
    const {exercisePerWeek, smoke, physicalExam, averageSleep, waterIntake, bodyPain, prescription, physicalActive}=this.state;
    const parentStyles = { width: "597px" };
    const exerciseDetail = [t("0 Day"), t("1 Day"), t("2 Days"), t("3 Days"), t("4 Days"), t("5 Days"), t("6 Days"), t("7 Days")];
    const smokeDetails = [t("Yes (Heavy Smoker)"), t("Yes (Casual Smoker / Trying To Quit)"), t("No (I Don't Smoke At All)")];
    const physicalExamDetails = [t("Every 5+ Years"), t("Every 3+ Years"), t("Every 1+ Years"), t("Every Year")];
    const averageSleepDetails = [t("9 Hours"), t("8 Hours"), t("7 Hours"), t("6 Hours Or Less")];
    const averageWaterDetails = [t("20 Ounces Or Less"), t("20 - 40 Ounces"), t("40 - 60 Ounces"), t("60 - 80 Ounces"), t("80 Ounces Or More")];
    const experiencePainDetails = [t("Daily"), t("Weekly"), t("Monthly"), t("Annually"), t("Rarely OR Never")];
    const prescriptionDetails = [t("0"), t("1"), t("2"), t("3+")];
    const minuteActiveDetails = [t("Less Than 15 Minutes"), t("15 - 30 Minutes"), t("30 - 45 Minutes"), t("45+ Minutes")];
    return(
      <WbaReportCard style={{marginBottom:"400px"}}>
        <div className='heading'>
          <div className='start'>
            <div className='title'>My General Health Information</div>
          </div>
          <div className='end'>
            <CommonButton padding="6px 0px" width="160px" onClick={()=>this.editGeneralProfileInfo()}> Save Changes{RecognitionTickIcon("white")}</CommonButton>
          </div>
        </div>
        <div className='border'/>
        <div className='category-wrapper' style={{gap:"0 20px"}}>
          <GeneralInfoPopup>
            <div className='title'>How many days a week do you exercise?</div>
            <div className='dropdown'>
              <CommonFilterDropdown
                options={exerciseDetail}
                selectedOption={exercisePerWeek}
                setSelectedOption={this.selectOptionValue}
                dropdownHeight={"auto"}
                dropdownWidth="597px"
                customStyles={parentStyles}
                stateValue={'exercisePerWeek'}
              />
            </div>
          </GeneralInfoPopup>
          <GeneralInfoPopup>
            <div className='title'>Do you smoke?</div>
            <div className='dropdown'>
              <CommonFilterDropdown
                options={smokeDetails}
                selectedOption={smoke}
                setSelectedOption={this.selectOptionValue}
                dropdownHeight={"auto"}
                dropdownWidth="597px"
                customStyles={parentStyles}
                stateValue={'smoke'}
              />
            </div>
          </GeneralInfoPopup>
          <div className='border'/>
          <GeneralInfoPopup>
            <div className='title'>How often do you have a physical exam?</div>
            <div className='dropdown'>
              <CommonFilterDropdown
                options={physicalExamDetails}
                selectedOption={physicalExam}
                setSelectedOption={this.selectOptionValue}
                dropdownHeight={"auto"}
                dropdownWidth="598px"
                customStyles={parentStyles}
                stateValue={'physicalExam'}
              />
            </div>
          </GeneralInfoPopup>
          <GeneralInfoPopup>
            <div className='title'>How many hours of sleep do you get on average each night?</div>
            <div className='dropdown'>
              <CommonFilterDropdown
                options={averageSleepDetails}
                selectedOption={averageSleep}
                setSelectedOption={this.selectOptionValue}
                dropdownHeight={"auto"}
                dropdownWidth="598px"
                customStyles={parentStyles}
                stateValue={'averageSleep'}
              />
            </div>
          </GeneralInfoPopup>
          <div className='border'/>
          <GeneralInfoPopup>
            <div className='title'>What is your average daily water intake?</div>
            <div className='dropdown'>
              <CommonFilterDropdown
                options={averageWaterDetails}
                selectedOption={waterIntake}
                setSelectedOption={this.selectOptionValue}
                dropdownHeight={"auto"}
                dropdownWidth="598px"
                customStyles={parentStyles}
                stateValue={'waterIntake'}
              />
            </div>
          </GeneralInfoPopup>
          <GeneralInfoPopup>
            <div className='title'>How frequently do you experience body pain?</div>
            <div className='dropdown'>
              <CommonFilterDropdown
                options={experiencePainDetails }
                selectedOption={bodyPain}
                setSelectedOption={this.selectOptionValue}
                dropdownHeight={"auto"}
                dropdownWidth="598px"
                customStyles={parentStyles}
                stateValue={'bodyPain'}
              />
            </div>
          </GeneralInfoPopup>
          <div className='border'/>
          <GeneralInfoPopup>
            <div className='title'>How many prescription medications do you take each day?</div>
            <div className='dropdown'>
              <CommonFilterDropdown
                options={prescriptionDetails}
                selectedOption={prescription}
                setSelectedOption={this.selectOptionValue}
                dropdownHeight={"auto"}
                dropdownWidth="598px"
                customStyles={parentStyles}
                stateValue={'prescription'}
              />
            </div>
          </GeneralInfoPopup>
          <GeneralInfoPopup>
            <div className='title'>How many minutes are you physically active each day?</div>
            <div className='dropdown'>
              <CommonFilterDropdown
                options={minuteActiveDetails}
                selectedOption={physicalActive}
                setSelectedOption={this.selectOptionValue}
                dropdownHeight={"auto"}
                dropdownWidth="598px"
                customStyles={parentStyles}
                stateValue={'physicalActive'}
              />
            </div>
          </GeneralInfoPopup>
        </div>
      </WbaReportCard>
    )
  }

  redirectSurveyAssessment = (id) => {
    const { fetchSurveyQuestions, history } = this.props;
    fetchSurveyQuestions(id, history, this.successFunc)
  };

  successFunc =()=>{
    this.props.history.push({pathname:`/survey`, state:{surveyCategory:"challengeSurvey"}})
  }

  getInitiativesCard = () => {
    const {userInitiativesData}=this.props;
    return(
      <WbaReportCard>
        <div className='heading'>
          <div className='start'>
            <div className='title'>Wellness Initiatives</div>
          </div>
        </div>
        <div className='border'/>
        <div className='category-wrapper' style={{flexWrap:"wrap",gap:"20px 20px"}}>
          {userInitiativesData?.map((data,index)=>{
            const completedDate=dayjs(new Date(data?.date)).format("MMM DD"); 
            return(
              <InitiativesCard key={index} color={data?.color}>
                <div className='icon'>
                  <img src={ImageUrl+"/"+ data?.initiative_white_icon} alt="icon"/>
                </div>
                <div className='wrap'>
                  <div className='title'>{data?.name}</div>
                  <div className='points'>+{data?.points}{" "}pts</div>
                  {data?.is_taken?<div className='completed'>Completed on {completedDate}</div>:
                    <div className='initiative-button' onClick={data?.type === "SURVEY" && data?.is_taken===0 ? () =>this.redirectSurveyAssessment(data?.survey_id) : data?.type === "HRA" && data?.is_taken===0? () => this.showInitiativeModal(data) : data?.type === "SYNC_DEVICE" && data?.is_taken===0?() => this.displayDeviceModal() : data?.type === "BIOMETRIC" && data?.is_taken===0 ? () => this.showInitiativeModal(data): data?.type === "BIOMETRIC" && data?.is_taken===0 ? () => this.showBiometricSubmitStatusPop() :data?.type === "GOALS" && data?.is_taken===0?() => this.showModal('monthlyGoals'): (data?.type === "OTHER") && data?.is_taken===0? () => this.showInitiativeModal(data):null}>Log Initiative {AdminRightArrowIcon("#DA6C74")}</div>}
                </div>
              </InitiativesCard>
            )})
          }
        </div>
      </WbaReportCard>
    )
  }

  userInitiativePopup = () => {
    const { showPopup, initiativeData } = this.state;
    const { history, user } = this.props;
    return (
      <StyledModal show={showPopup} width={initiativeData.about ? "600px" : "400px"} height={"480"}>
        <div className={'modal-container'}>
          <div onClick={() => this.hideInitiativeModal()} style={{ margin: '14px 0px 0px -14px', cursor: 'pointer' }}>
            {closeIcon()}
            {/* <img src="/public/images/NewDashboardV2/crossIconNew.png" alt="close" /> */}
          </div>
          <div style={{ color: '#005C87', marginTop: '0px', textDecoration: 'none', fontSize: '18px'}}>
          Recommended To Complete
            {/* {initiativeData.name} */}
          </div>
        </div>
        <Border style={{background:'rgba(0, 92, 135, 0.10)',margin:'20px 0px 0px 0px'}}/>
        <Modal.Body style={{padding:"24px"}}>
          <InitiativesContainer>
            <div className='icon-name'>
              <div className={'initiative-new-icon'}><img src={`${ImageUrl}/${initiativeData.logo}`} alt="logo" /></div>
              <div className='name'>{initiativeData.name}</div>
            </div>

            {initiativeData.about ? <><div className={'ini-name'}>
              {/* {initiativeData.name} */}
              About the initiative
            </div>
            <div className='about'>
              {parse(initiativeData.about)}
            </div>
            </>: null
            }
            {/* <div className={'details'}>
              <div className={'name'}>
                {initiativeData.name}
              </div>
              <div className='about'>
                {initiativeData.about}
              </div>
            </div> */}
            {/* <div className={'details'}>
              {t("by clicking the button below")}.
            </div> */}
            <ButtonContainer>
              <ConfirmButton onClick={initiativeData.type === "HRA"?()=>history.push('/wellness-assessment'):initiativeData.type === "BIOMETRIC"?()=>history.push(`/profile/biometric/${user.uid}/multi-step/physician-form`): /* () => this.showCalendar() */ () => this.showConfirmVisitModal()} margin="30px auto 5px auto" width="352px" style={{ background: "#007AB1" }}>{initiativeData.type === "HRA"||initiativeData.type === "BIOMETRIC"?("Next"):("Confirm Details")}</ConfirmButton>
            </ButtonContainer>
          </InitiativesContainer>
        </Modal.Body>
      </StyledModal>)
  }

  confirmDetails = () => {
    const { isConfirmDetails, initiativeData } = this.state;
    const { t } = this.props;
    return (
      <StyledModal show={isConfirmDetails} width={"400px"} height={"380"}>
        <div>
          <div style={{ color: '#005C87', marginTop: '20px', textDecoration: 'none', display: 'flex', justifyContent: 'center' }}>
            {GreatJobIcon()}<span style={{ color: '#005C87', fontFamily: 'Rubik-Medium', fontSize: '18px', lineHeight: '24px', marginLeft: '10px' }}>{t("Great job!")}</span>
          </div>
        </div>
        <Border style={{background:'rgba(0, 92, 135, 0.10)',margin:'20px 0px 0px 0px'}}/>
        <Modal.Body>
          <InitiativesContainer>
            <div className='text-style'>
              <div style={{ fontFamily: "Rubik", fontSize: '18px', lineHeight: '24px', textAlign: "center", fontWeight: '400', color: '#005C87' }}>
                {("You completed your")}&nbsp;
                <div>
                  {initiativeData.name}
                </div>
              </div>
            </div>
            <div className={'initiative-icon'} style={{ marginTop: '25px' }}>
              <img src={`${ImageUrl}/${initiativeData.logo}`} alt="logo" />
            </div>
            
            <div className='text-style' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{ fontFamily: "Rubik-Medium", fontSize: '18px', lineHeight: '24px', color: '#005C87' }}><span style={{ marginRight: '5px' }}>{("Congratulations!")}</span> {CongratulationsEmojiIcon()}&nbsp;</div>
              <div style={{ fontFamily: "Rubik", fontSize: '18px', lineHeight: '24px', textAlign: "center", fontWeight: '400', color: '#005C87' }}>
                {initiativeData.points === 0 ? `You have done a great job` : `You earned +${initiativeData.points} Points`}
              </div>
            </div>
            <ButtonContainer>
              <ConfirmButton onClick={() => this.hideIsConfirmDetails()} margin="30px auto 5px auto" width="352px" style={{ background: "#007AB1" }}>{("Thank You!")}</ConfirmButton>
            </ButtonContainer>
          </InitiativesContainer>
        </Modal.Body>
      </StyledModal>)
  }

  hideshowbiometricpopup = () =>  {
    this.setState({
      showBiometricInfoPopup:!this.state.showBiometricInfoPopup
    })
  }

  hideConfirmPopup = () => {
    this.setState((prev) => ({
      confirmVisit: !prev.confirmVisit,
    }))
  }

  showThankyouPopup = () => {
    const { postUserInitiatives } = this.props;
    const { initiativeData, currentDate } = this.state;
    let initiativeDate = moment(currentDate).format("YYYY-MM-DD");
    const initiativesData = {
      initiative_id: initiativeData.initiative_id,
      date: initiativeDate
    };
    postUserInitiatives(initiativesData);
    this.setState((prev) => ({
      confirmVisit: !prev.confirmVisit, showThankyou: !prev.showThankyou,
    }))
  }

  hideThankyouPopup = () => {
    this.setState((prev) => ({
      showThankyou: !prev.showThankyou,
    }))
  }

  hideConfirmVisitModal = () => {
    this.setState((prev) => ({
      showConfirmVisitModal: !prev.showConfirmVisitModal,
    }))
  }

  showIsConfirmDetails = () => {
    this.setState((prev) => ({
      isConfirmDetails: !prev.isConfirmDetails,
    }))
    this.hideConfirmVisitModal();
  }

  hideIsConfirmDetails = () => {
    this.setState((prev) => ({
      isConfirmDetails: !prev.isConfirmDetails,
    }))
  }

  showInitiativeModal = (data) => {
    this.setState((prev) => ({
      showPopup: !prev.showPopup, initiativeData: data
    }))
  };

  showConfirmVisitModal = () => {
    this.setState((prev) => ({
      showConfirmVisitModal: !prev.showConfirmVisitModal,
    }))
    this.hideInitiativeModal()
  }

  hideInitiativeModal = () => {
    this.setState((prev) => ({
      showPopup: !prev.showPopup,
    }))
  };

  hideDeviceModal = () => {
    this.setState({ showDeviceModal: false });
  };

  displayDeviceModal = () => {
    this.props.fetchConnectedDevices();
    this.setState({ showDeviceModal: true })
  };

  showModal = (name) => {
    this.setState({
      modalName: name,
    });
  };

  hideModal = () => {
    this.setState({
      modalName: ''
    });
  };

  render() {
    const { history, /*wellnessGoals,*/ wellnessAssessment, brandingColor, user, devices, devicesDisconnected, revokeDevice, SetDailyGoal, inputGoals, /*userBiometric*/ } = this.props;
    const{activeTab, showCompareYear, showBiometricInfoPopup, confirmVisit, currentDate, initiativeData, showThankyou, showConfirmVisitModal, showPopup, isConfirmDetails, showDeviceModal, modalName, isEditInfo}=this.state;
    if (isNull(wellnessAssessment) && isUndefined(wellnessAssessment)) {
      return <Waiting />
    }
    let dateData = moment(currentDate).format('MMM DD, YYYY');
    const currentMonth=dayjs(new Date).format("MMMM");
   
    return (
      <>
        <MainContainer margin>
          <TopContainerWrapper style={{ flexWrap: "wrap" }}>
            <TabsWrapper background="transparent" padding="15px 0px">
              <TabBottomLine active={activeTab === 'health-hub'} background={brandingColor} onClick={() => this.setState({activeTab:"health-hub"})}>
                Health Hub
                <BorderBottom active={activeTab === 'health-hub'} background={brandingColor} />
              </TabBottomLine>
              <TabBottomLine active={activeTab === 'reports'} background={brandingColor} onClick={() => this.setState({activeTab:"reports"})}>
                Reports
                <BorderBottom active={activeTab === 'reports'} background={brandingColor} />
              </TabBottomLine>
              <TabBottomLine active={activeTab === 'history'} background={brandingColor} onClick={() => this.setState({activeTab:"history"})}>
                History
                <BorderBottom active={activeTab === 'history'} background={brandingColor} />
              </TabBottomLine>
            </TabsWrapper>
          </TopContainerWrapper> 
        </MainContainer>
        {activeTab === "health-hub"?      <div>
          <div style={{display:'flex'}}>
            {this.getWbaReport(wellnessAssessment)}
            {this.getBiometricReport()} 
            {/* {userBiometric?.weight&&userBiometric?.height&& this.getBiometricReport()}  */}
          </div>
          {/* <OverviewCardV2>
            <div className='view-card'>
              <div className='prof-details'>
                <div className='name-in'>{this.props.t("My")} {moment().format('YYYY')} {this.props.t("Fitness Goal")}</div>
                <button onClick={() => history.push('/settings')} className='user-edit-btn'>{this.props.t("Edit Goal")}</button>
              </div>
              <hr className='horizontal-line' />
              <div className='emp-detail'>
                <div className='fieldNames'>
                  <div className='label-name-emp'>{this.props.t("Health")}: </div>
                  {wellnessGoals?.other_goals[0] && wellnessGoals?.other_goals?.length > 0 ? <div className='prof-data'>{wellnessGoals?.other_goals[0]?.name}</div> : <div style={{ color: '#0D4270' }}>-</div>}
                </div>
                <div className='fieldNames'>
                  <div className='label-name-emp'>{this.props.t("Performance")}: </div>
                  {wellnessGoals?.top_goals[0] && wellnessGoals?.top_goals?.length > 0 ? <div className='prof-data'>{wellnessGoals?.top_goals[0]?.name}</div> : <div style={{ color: '#0D4270' }}>-</div>}
                </div>
                <div className='fieldNames'>
                  <div className='label-name-emp'>{this.props.t("Behavioral")}: </div>
                  {wellnessGoals?.other_goals[1] && wellnessGoals?.other_goals?.length > 0 ? <div className='prof-data'>{wellnessGoals?.other_goals[1]?.name}</div> : <div style={{ color: '#0D4270' }}>-</div>}
                </div>
                <div className='fieldNames'>
                  <div className='label-name-emp'>{this.props.t("Racing and Competition")}: </div>
                  {wellnessGoals?.other_goals[2] && wellnessGoals?.other_goals?.length > 0 ? <div className='prof-data'>{wellnessGoals?.other_goals[2]?.name}</div> : <div style={{ color: '#0D4270' }}>-</div>}
                </div>
              </div>
    
            </div>
          </OverviewCardV2> */}
          {this.getInitiativesCard()}
          {!isEditInfo? this.generalInfoCard():this.editGeneralInfoCard()} 
          {this.state.biometricPopupStatus && 
            <BiometricDetails
              showModal={this.state.biometricPopupStatus}
              closeModal={this.showBiometricSubmitStatusPop}
            />
          }
        </div>:activeTab === "reports"? <Reports user={this.props.user}/> : activeTab === "history"? <History user={this.props.user} getTotalWellbeingPercentage={this.getTotalWellbeingPercentage} wellnessAssessment={wellnessAssessment}/> :null}
        {showCompareYear&&this.comparisonModal()}
        {showBiometricInfoPopup&&this.biometricInfoPopup()}
        {/* {showPopup && this.userInitiativePopup()} */}
        {showPopup && <UserInitiativePopup
          showPopup={showPopup}
          initiativeData={initiativeData}
          history={history}
          user={user}
          onClose={this.hideInitiativeModal}
          showConfirmVisitModal={this.showConfirmVisitModal}
          title={'Recommended To Complete'}
        />}
        {confirmVisit && <ConfirmVisitPopup confirmVisit={confirmVisit} hideConfirmPopup={this.hideConfirmPopup} showThankyouPopup={this.showThankyouPopup} currentDate={dateData} initiativeData={initiativeData} name={user?.fname} />}
        

        {showThankyou && <ThankyouPopup hideThankyouPopup={this.hideThankyouPopup} showThankyou={showThankyou} initiativeData={initiativeData} />}
        {showConfirmVisitModal && <ConfirmDetailsModal showConfirmVisitModal={showConfirmVisitModal} hideConfirmVisitModal={this.hideConfirmVisitModal} showIsConfirmDetails={this.showIsConfirmDetails} hideIsConfirmDetails={this.hideIsConfirmDetails} initiativeData={initiativeData} name={user?.fname} getUserCompanyItitiatives={this.props.getUserCompanyItitiatives} />}
        {/* {isConfirmDetails && this.confirmDetails()} */}
        {isConfirmDetails && <InitiativeCompleteModal isConfirmDetails={isConfirmDetails} initiativeData={initiativeData} hideIsConfirmDetails={this.hideIsConfirmDetails}/>}

        {devices && devices?.length > 0 && showDeviceModal&&<ConnectDeviceModal
          showModal={showDeviceModal}
          closeModal={this.hideDeviceModal}
          devices={devices}
          revokeDevice={revokeDevice}
          devicesDisconnectedList={devicesDisconnected}
        />}
        {modalName === 'monthlyGoals'&&<InputGoalV2
          showModal={modalName === 'monthlyGoals'}
          onHide={this.hideModal}
          SetDailyGoal={SetDailyGoal}
          inputGoals={inputGoals}
          userName={user?.fname}
          month={currentMonth}
        />}
      </>
    )
  }
}

HealthAndWellness.propTypes = {
  userModal: PropTypes.func,
  user: PropTypes.object,
  interest: PropTypes.object,
  wellnessInitiatives: PropTypes.array,
  userRecognitionCount: PropTypes.array,
  history: PropTypes.object.isRequired,
  wellnessGoals: PropTypes.object,
  health: PropTypes.array,
  userBiometric: PropTypes.array,
  wellnessAssessment: PropTypes.array,
  t: PropTypes.func,
  brandingColor:PropTypes.string,
  companyInfo: PropTypes.object,
  userCompany: PropTypes.object,
  postUserInitiatives: PropTypes.func,
  getUserCompanyItitiatives: PropTypes.func,
  fetchSurveyQuestions: PropTypes.func,
  fetchConnectedDevices: PropTypes.func,
  devices: PropTypes.array,
  devicesDisconnected: PropTypes.array,
  revokeDevice: PropTypes.func.isRequired,
  SetDailyGoal: PropTypes.func,
  inputGoals: PropTypes.object,
  userInitiativesData: PropTypes.array,
  submitHealthInformation: PropTypes.func,
  showHRAPopUp: PropTypes.bool
};

const mapStateToProps = (state) => ({
  user: state.profileData.user,
  devices: state.wellnessDashboard.devices,
  devicesDisconnected: state.profileData.devicesDisconnected,
  inputGoals: state.profileData.inputGoals,
  userInitiativesData: state.profileData.userInitiatives,
  showHRAPopUp: state.profileData.showHideHra
});
const mapDispatchToProps = (dispatch) => ({
  postUserInitiatives: (initiativesData) => dispatch(postUserInitiatives(initiativesData)),
  getUserCompanyItitiatives: () => dispatch(getUserCompanyItitiatives()),
  fetchSurveyQuestions: (id, history, successFunc) => dispatch(FetchSurveyQuestions(id, history, successFunc)),
  fetchConnectedDevices: () => dispatch(getListOfConnectedDevices()),
  revokeDevice: (name) => dispatch(revokeDevice(name)),
  SetDailyGoal: (dailyGoalData) => dispatch(SetDailyGoal(dailyGoalData)),
  submitHealthInformation: (obj) => dispatch(submitHealthInformation(obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(HealthAndWellness));
